import { browser } from '$app/environment';

import Routes from '$provider/constants/Route';
import ServiceErrorWrapper from '$shared/helpers/decorators/ServiceErrorWrapper';
import globalAlert from '$shared/stores/globalAlertStore';
import { screenshotPreviewStore } from '$provider/stores/screenshotPreviewStore';
import fileService from '$shared/services/fileService';
import { api } from '../api';

class ScreenshotService {
  private screenshots: Map<string, string> = new Map();
  constructor() {
    if (browser) {
      window.addEventListener('service:route-change', this.onRouteChange);
    }
  }
  public async getAllScreenshotAsync(paths: string[]): Promise<string[]> {
    const screenshots = await Promise.all(paths.map((path) => this.getScreenshotAsync(path)));
    this.dispatchScreenshotLoaded();
    return screenshots;
  }
  @ServiceErrorWrapper()
  public async getScreenshotAsync(path: string): Promise<string> {
    if (this.isBlobUrl(path)) {
      return path;
    }
    if (this.screenshots.has(path)) {
      return this.screenshots.get(path);
    }
    const blob = await api.getFileAsync(path);
    const dataUrl = await fileService.getDataUrlAsync(blob, 'image/png');
    this.screenshots.set(path, dataUrl);
    return dataUrl;
  }
  public openPreview(url: string): void {
    if (!url) {
      globalAlert.show(
        { message: 'Unable to display screenshot preview, Invalid screenshot URL received' },
        true
      );
      return;
    }
    screenshotPreviewStore.openPreview(url);
  }
  public closePreview(): void {
    screenshotPreviewStore.reset();
  }
  private isBlobUrl(path: string): boolean {
    let url: URL;
    try {
      url = new URL(path);
    } catch {
      return false;
    }
    return url.protocol === 'blob:';
  }
  private onRouteChange = () => {
    if (window.location.pathname.includes(Routes.ProviderDetailOverview.split('/')[1])) {
      return;
    }
    this.reset();
  };
  private reset(): void {
    this.screenshots.clear();
  }
  private dispatchScreenshotLoaded(): void {
    window.dispatchEvent(new CustomEvent('service:screenshot-loaded'));
  }
}

export default new ScreenshotService();
